<div class="app-container">
  <loading-spinner [isLoading]="loading()" [classesString]="'top-50'"></loading-spinner>
  @if (isCreating() || (!isCreating() && !this.querySupplier.isPending())) {
    <form [formGroup]="supplierForm" (ngSubmit)="isCreating() ? createSupplier.mutate() : updateSupplier.mutate()">
      <page-header
        [icon]="'far-truck'"
        [title]="isCreating() ? 'supplier.new' : 'supplier'"
        [appendNoTranslationTitlePart]="querySupplier.data() ? querySupplier.data().name : ''"
      >
        <ng-container class="header-button">
          <btn
            [btnType]="'submit'"
            [icon]="'far-check'"
            [classes]="['btn-first', 'float-right']"
            [label]="'save'"
            [title]="'save' | translate"
            [isLoading]="loading()"
            [btnDisabled]="loading()"
            [spinnerClassesString]="'spinner-white'"
            [dataCyAttribute]="'create-supplier'"
          ></btn>
          @if (!isCreating()) {
            <btn
              [btnType]="'button'"
              [classes]="['btn-first-red', 'float-right', isCreating() ? '' : 'me-2']"
              (onEvent)="deleteSupplier.mutate()"
              [icon]="'far-trash-alt'"
              [label]="'delete'"
              [title]="'delete' | translate"
              [dataCyAttribute]="'delete-supplier'"
            ></btn>
          }
        </ng-container>
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <form-row-input
                [formGroup]="supplierForm"
                formControlName="name"
                [required]="supplierForm.get('name').errors !== null && supplierForm.get('name').errors.required"
                [requiredCssClass]="submitted() && formControls.name.errors"
                [label]="'supplier.name'"
                [icon]="'far-list'"
                [dataCyAttribute]="'name'"
              ></form-row-input>
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</div>
